'use strict'

import React from 'react'
import PropTypes from 'prop-types'

/**
 * セルドット（項目の設定状態を表示）
 *
 * 必須 と 任意 は**背景の有無**で区別する（凡例の白背景チップと対応）。 ドットの色は両者で共通（設定済=緑 / 不要=グレー / 未設定=赤）。
 *
 * @param {boolean} required - 必須項目かどうか
 * @param {boolean} optional - 任意項目かどうか（背景なしで描画）
 * @param {string | null} status - 設定状態 ('set' | 'remove' | 'unset' | null)
 * @param {boolean} isHeader - ヘッダー行かどうか
 */
function CellDot({ required, optional, status, isHeader }) {
  if (!required && !optional) {
    return <span className="matrix-cell-dot matrix-cell-dot--not-required">–</span>
  }
  const title = status === 'set' ? '設定済' : status === 'remove' ? '不要' : '未設定'
  // 任意 は背景なし。必須 のみ背景色（設定済=緑 / それ以外=赤）を付ける
  const bgClass = isHeader || optional ? 'bg-transparent' : status === 'set' ? 'bg-green-100' : 'bg-red-100'
  const dotClass = status === 'set' ? 'bg-green-500' : status === 'remove' ? 'bg-gray-400' : 'bg-red-500'
  return (
    <span className={`matrix-cell-dot ${bgClass}`}>
      <span className={`matrix-cell-dot__dot ${dotClass}`} title={title} />
    </span>
  )
}

CellDot.propTypes = {
  required: PropTypes.bool.isRequired,
  optional: PropTypes.bool,
  status: PropTypes.oneOf(['set', 'remove', 'unset', null]),
  isHeader: PropTypes.bool
}

CellDot.defaultProps = {
  optional: false,
  status: null,
  isHeader: false
}

// セルは行 × 列で大量に描画されるため、props（required/optional/status/isHeader）が変わらない限り再レンダーしない。
export default React.memo(CellDot)
